module.exports = __webpack_public_path__ + "img/10979912_L.584b8997.png";